import { InputText } from 'primereact/inputtext';
import { Dropdown } from 'primereact/dropdown';
import { Button } from 'primereact/button';
import { Calendar } from 'primereact/calendar';
import { MultiSelect } from 'primereact/multiselect';
import { useEffect, useState } from 'react';
import RawMaterialService from '../../services/RawMaterials/RawMaterialService';
import { Toast } from 'primereact/toast';
import { useRef } from 'react';



interface RawMaterialsSearchProps {
  onSearch: (filters: {
    rawMaterialId?: Number;
    supplierId?: number;
     rmCategoryId?: number; 
    activeOnly?: boolean;
    startDate?: string;
    endDate?: string;
     keyword?: string; 
      invoiceNumber?: string;
  }) => void;
  onReset: () => void;
  totalRecords: number;
}

const RawMaterialsSearch: React.FC<RawMaterialsSearchProps> = ({ 
  onSearch, 
  onReset,
  totalRecords
}) => {
  const [materialName, setMaterialName] = useState('');
  const [MaterialId, setMaterialId] = useState<number | null>(null);
  const [Rawmaterials, setRawmaterials] = useState<any[]>([]);
  const [category, setcategory] = useState<any[]>([]);
  const [categoryId, setcategoryId] = useState<number | null>(null);
  const [startDate, setStartDate] = useState<Date | null>(null);
  const [endDate, setEndDate] = useState<Date | null>(null);
  const [filterApplied, setFilterApplied] = useState(false);
const [keyword, setKeyword] = useState<string>("");
const toast = useRef<Toast>(null);
const [InvoiceNos, setInvoiceNos] = useState<{ invoiceNumber: string }[]>([]);
const [selectedInvoiceNo, setSelectedInvoiceNo] = useState<string | null>(null);
  const [hoveredField, setHoveredField] = useState<string | null>(null);

useEffect(() => {
  const fetchRawMaterials = async () => {
    try {
      const response = await RawMaterialService.getRawMaterials();

      setRawmaterials(response || []);
    } catch (error) {
      console.error("Error fetching raw materials:", error);
    }
  };

  const fetchCategories = async () => {
  try {
    const response = await RawMaterialService.RMCategories(); 
    setcategory(response || []);
  } catch (error) {
    console.error("Error fetching categories:", error);
  }
};
const fetchInvoiceNos = async () => {
  try {
    const response = await RawMaterialService.getInvoicenos(); 
      console.log(" fetchInvoiceNos response:", response);
    setInvoiceNos(response || []);
  } catch (error) {
    console.error("Error fetching categories:", error);
  }
};

  fetchRawMaterials();
  fetchCategories();
  fetchInvoiceNos();
  
}, []);

const formatDate = (date: string | Date): string => {
  const d = new Date(date);
  const day = String(d.getDate()).padStart(2, '0');
  const month = String(d.getMonth() + 1).padStart(2, '0');
  const year = d.getFullYear();
  return `${day}-${month}-${year}`;
};

const formatDateWithoutTimezone = (date: Date): string => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`; 
};


useEffect(() => {
  const delayDebounce = setTimeout(() => {
    if (keyword.trim() !== "") {
      onSearch({
        rawMaterialId: MaterialId || undefined,
        rmCategoryId: categoryId || undefined,
        startDate: startDate ? formatDateWithoutTimezone(startDate) : undefined,
        endDate: endDate ? formatDateWithoutTimezone(endDate) : undefined,
        keyword: keyword.trim()
      });
    }
  }, 500); 

  return () => clearTimeout(delayDebounce);
}, [keyword, MaterialId, categoryId, startDate, endDate]);



     const handleSearch = () => {
  if (
    !keyword.trim() &&
    !MaterialId &&
    !categoryId &&
    !startDate &&
    !endDate &&
     !selectedInvoiceNo
  
  ) {
    toast.current?.show({
  severity: 'warn',   // 'error' -> 'warn' for softer UX
  summary: '⚠️ Missing Filters',
  detail: 'Please choose at least one filter.',
  life: 4000
});
    return;
  }
  if (startDate && !endDate) {
  toast.current?.show({
    severity: 'warn',
    summary: ' Missing Date',
    detail: 'Please select an End Date to complete the range.',
    life: 4000
  });
  return;
}

if (!startDate && endDate) {
  toast.current?.show({
    severity: 'warn',
    summary: ' Missing Date',
    detail: 'Please select a Start Date to complete the range.',
    life: 4000
  });
  return;
}


  if (startDate && endDate && endDate < startDate) {
    toast.current?.show({
      severity: 'warn',
      summary: 'Validation Error',
      detail: 'End Date cannot be earlier than Start Date.',
      life: 3000
    });
    return;
  }

    onSearch({ 
      rawMaterialId: MaterialId || undefined,
      rmCategoryId:categoryId||undefined,
        startDate: startDate ? formatDateWithoutTimezone(startDate) : undefined,
    endDate: endDate ? formatDateWithoutTimezone(endDate) : undefined,
     keyword: keyword || undefined, 
       invoiceNumber: selectedInvoiceNo || undefined  
    });
    setFilterApplied(true);
  };

    const fieldHoverStyle = (fieldName: string) => ({
    border: hoveredField === fieldName ? "2px solid #63f192ff" : "1px solid #ced4da",
    boxShadow: hoveredField === fieldName ? "0 0 6px rgba(99, 102, 241, 0.3)" : "none",
    transition: "all 0.2s ease-in-out",
    width: "100%",
    minHeight: "40px",
  });

  const handleReset = () => {
    setMaterialName('');
    setMaterialId(null);
    setcategoryId(null);
    setStartDate(null);
    setEndDate(null);
    setFilterApplied(false);
     setKeyword(""); 
       setSelectedInvoiceNo(null);  
    onReset();
  };

  return (
   
    <div className="flex flex-wrap align-items-center justify-content-between gap-3">
 <Toast ref={toast} />
  <div style={{ flex: '1 1 18%' }}>
  <InputText
   
    value={keyword}
    onChange={(e) => setKeyword(e.target.value)}
    placeholder="Search keyword"
    className="w-full"
    onKeyDown={(e) => {
      if (e.key === "Enter") handleSearch();  
    }}
  />
</div>

  {/* <div style={{ flex: '1 1 18%' }}>
    <Dropdown
      id="id"
      name="id"
      value={MaterialId}
      options={Rawmaterials}
      optionLabel="name"
      optionValue="id"
      placeholder="Select RawMaterial"
      onChange={(e) => setMaterialId(e.value)}
      className="w-full"
    />
  </div> */}

  <div style={{ flex: '1 1 18%' }}>
  <Dropdown
    id="id"
    name="id"
    value={MaterialId}
    options={Rawmaterials}
    optionLabel="name"
    optionValue="id"
    placeholder="Select RawMaterial"
    onChange={(e) => setMaterialId(e.value)}
    className="w-full"
    filter
    filterBy="name"
    showFilterClear
    filterMatchMode="startsWith"
    filterPlaceholder="Search raw materials..."
  />
</div>
   <div style={{ flex: '1 1 18%' }}>
    <Dropdown
  value={selectedInvoiceNo}
  options={InvoiceNos}
  optionLabel="invoiceNumber"
  optionValue="invoiceNumber"
  placeholder="Select InvoiceNumber"
  onChange={(e) => setSelectedInvoiceNo(e.value)}
  className="w-full"
   filter
    filterBy="invoiceNumber"
    showFilterClear
    filterMatchMode="startsWith"
/>
  </div>

  

  <div style={{ flex: '1 1 18%' }}>
    <Dropdown
      id="categoryID"
      name="categoryID"
      value={categoryId}
      options={category}
      optionLabel="categoryName"
      optionValue="categoryID"
      placeholder="Select Category"
      onChange={(e) => setcategoryId(e.value)}
      className="w-full"
       filter
    filterBy="categoryName"
    filterMatchMode="startsWith"
    showFilterClear
    />
  </div>
 
<div className="flex flex-wrap gap-3 w-full mt-2">
  <div style={{ flex: "1 1 11%" }}>
    {/* Start Date */}
    <Calendar
      value={startDate}
      onChange={(e) => setStartDate(e.value as Date)}
      placeholder="Start Date"
      dateFormat="dd-mm-yy"
      readOnlyInput
      inputRef={(el) => {
        if (el) el.readOnly = true;
      }}
      className="w-full"
    />
  </div>

  <div style={{ flex: "1 1 11%" }}>
    {/* End Date */}
    <Calendar
      value={endDate}
      onChange={(e) => setEndDate(e.value as Date)}
      placeholder="End Date"
      dateFormat="dd-mm-yy"
      readOnlyInput
      inputRef={(el) => {
        if (el) el.readOnly = true;
      }}
      className="w-full"
    />
  </div>

  <div style={{ flex: "1 1 20%" }} className="flex gap-2 justify-content-end">
    <Button
      label="Filter"
      className="p-button-success"
      onClick={handleSearch}
      style={{ width: "100px" }}
    />
    <Button
      label="Reset"
      className="text-black border-round p-button-m"
      severity="secondary"
      text
      raised
      onClick={handleReset}
      style={{ width: "100px" }}
    />
  </div>
</div>

  {filterApplied && (
  <div className="col-12 mt-2 ml-3 text-sm">
    <span className="text-black font-semibold text-lg">
      Number of Raw Materials: {totalRecords}
    </span>
  </div>
)}
</div>
  );
};

export default RawMaterialsSearch;


